import React from "react";
import SectionHeading from "../../components/sectionHeading";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, EffectCoverflow } from "swiper/modules";
import TopRankerCard from "../../components/topRankerCard";
import Testimonials from "../../components/testimonials";
import TopRankerListWithCategory from "../../components/topRankerListWithCategory";
import { useGetTopRankersQuery } from "../../api/services/topRankers";

const Toprankers = () => {
  const { data, isLoading } = useGetTopRankersQuery();

  if (isLoading) {
    return <>Loading</>;
  }
  return (
    <>
      <section className="section__row  section--topRankers">
        <div className="main__container ">
          <div className="section__contentBox">
            <SectionHeading
              customCls={"section__heading"}
              tagName={"h1"}
              title={"Meet Our Top Rankers"}
            />
          </div>
        </div>
        <div className="topRanker__swiper">
          <Swiper
            effect={"coverflow"}
            grabCursor={true}
            loop={true}
            centeredSlides={true}
            slidesPerView={"auto"}
            speed={1000}
            coverflowEffect={{
              rotate: 50,
              stretch: 0,
              depth: 100,
              modifier: 1,
              slideShadows: false,
            }}
            autoplay={{
              enabled: true,
              delay: 2500,
              pauseOnMouseEnter: true,
              disableOnInteraction: false,
            }}
            modules={[Navigation, Autoplay, EffectCoverflow]}
            className="mySwiperTopRankers"
          >
            {data
              ?.filter((x) => x.top_image)
              ?.map((item) => (
                <SwiperSlide key={item?.id}>
                  <TopRankerCard
                    key={item?.id}
                    thumb={item.top_image}
                    name={item.name}
                    rank={item.rank}
                    title={item.title}
                  />
                </SwiperSlide>
              ))}
          </Swiper>
        </div>
      </section>
      <TopRankerListWithCategory data={data} />
      <Testimonials />
    </>
  );
};

export default Toprankers;
